import clsx from 'clsx'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import s from './styles.module.scss'

import { ModalSelectProposalFooterPrice } from '../modal-select-proposal-footer-price/ModalSelectProposalFooterPrice'
import { MODAL_SELECT_PROPOSAL_MODE } from '../../modal-select-proposal.enum'
import { ISelectProposalHook } from '../../modal-select-proposal.types'
import { PriceObjectOutputDto } from '../../../../../lib/graphql'

const ModalSelectProposalFooterTotal = ({
  total,
  adults,
  mode,
  displayPricesAsEstimates,
  isAuthenticated,
  backoffice = false,
}: {
  total: Pick<PriceObjectOutputDto, 'priceWithDiscountAndFees'> | undefined
  adults: number | undefined
  mode: MODAL_SELECT_PROPOSAL_MODE
  isAuthenticated: ISelectProposalHook['isAuthenticated']
  displayPricesAsEstimates: boolean | undefined
  backoffice?: boolean
}) => {
  return (
    <div
      className={clsx(s.estimationContainer, {
        [s.estimationContainerHouseCard]:
          mode === MODAL_SELECT_PROPOSAL_MODE.IN_HOUSE_CARD,
      })}
    >
      <div className={s.estimation}>
        {displayPricesAsEstimates ? (
          <>
            <p>
              <FormattedMessage
                id='ui.ModalSelectProposalFooterTotal.quoteEstimate'
                defaultMessage='ESTIMATION DU DEVIS'
              />
            </p>
            <div className={s.priceContainer}>
              <ModalSelectProposalFooterPrice
                total={total}
                isAuthenticated={isAuthenticated}
                backoffice={backoffice}
              />
              <ModalSelectProposalFooterPrice
                total={total}
                isByPerson={true}
                adults={adults}
                isAuthenticated={isAuthenticated}
                backoffice={backoffice}
              />
            </div>
          </>
        ) : (
          <p>
            <FormattedMessage
              id='ui.ModalSelectProposalFooterTotal.rateQuoted24h'
              defaultMessage='TARIF SUR DEVIS EN MOINS DE 24H'
            />
          </p>
        )}
      </div>
    </div>
  )
}

export default ModalSelectProposalFooterTotal
